import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { List, X, CaretDown } from "@phosphor-icons/react";

export const LOGO_DARK = "/logo-dark.png";
export const LOGO_LIGHT = "/logo-light.png";
export const LOGO_EMBLEM = "/ebg-emblem.png";
export const LOGO_URL = LOGO_EMBLEM; // emblem-only mark (used by EcosystemOrbit)

export function Logo({ className = "", variant = "dark" }) {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="nav-logo">
      <img src={variant === "light" ? LOGO_LIGHT : LOGO_DARK} alt="EBG Franchise Partner" className="h-9 w-auto" />
    </Link>
  );
}

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/explore", label: "Explore Brands" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/about", label: "About EBG" },
];

export function Navbar() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [resOpen, setResOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-navy-950/80 backdrop-blur-xl border-b border-white/10">
      <div className="px-6 md:px-12 lg:px-20 h-16 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm tracking-wide transition-colors hover:text-gold ${pathname === l.to ? "text-gold" : "text-ebg-muted"}`}>
              {l.label}
            </Link>
          ))}
          <div className="relative" onMouseEnter={() => setResOpen(true)} onMouseLeave={() => setResOpen(false)}>
            <button data-testid="nav-resources" className="text-sm tracking-wide text-ebg-muted hover:text-gold flex items-center gap-1">
              Resources <CaretDown size={12} />
            </button>
            {resOpen && (
              <div className="absolute top-full left-0 pt-3">
                <div className="glass rounded-lg py-2 w-44">
                  <Link to="/faq" className="block px-4 py-2 text-sm text-ebg-muted hover:text-gold hover:bg-white/5">FAQ</Link>
                  <Link to="/contact" className="block px-4 py-2 text-sm text-ebg-muted hover:text-gold hover:bg-white/5">Contact</Link>
                  <Link to="/how-it-works" className="block px-4 py-2 text-sm text-ebg-muted hover:text-gold hover:bg-white/5">How It Works</Link>
                </div>
              </div>
            )}
          </div>
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          {user ? (
            <>
              {user.role === "admin" && <Link to="/admin" data-testid="nav-admin" className="text-sm text-ebg-muted hover:text-gold">Admin</Link>}
              <Link to="/portfolio" data-testid="nav-portfolio" className="text-sm text-ebg-muted hover:text-gold">Portfolio</Link>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm text-ebg-muted hover:text-gold">Dashboard</Link>
              <button data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }}
                className="text-sm border border-white/15 px-4 py-1.5 rounded-md hover:border-gold hover:text-gold transition-colors">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-ebg-muted hover:text-white">Login</Link>
              <Link to="/register" data-testid="nav-register" className="btn-gold text-sm px-5 py-2 rounded-md">Become a Partner</Link>
            </>
          )}
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 px-6 py-4 flex flex-col gap-4 bg-navy-950">
          {navLinks.map((l) => <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm text-ebg-muted">{l.label}</Link>)}
          <Link to="/faq" onClick={() => setOpen(false)} className="text-sm text-ebg-muted">FAQ</Link>
          <Link to="/contact" onClick={() => setOpen(false)} className="text-sm text-ebg-muted">Contact</Link>
          {user ? (
            <>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="text-sm text-gold">Admin</Link>}
              <Link to="/dashboard" onClick={() => setOpen(false)} className="text-sm text-gold">Dashboard</Link>
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="text-left text-sm text-ebg-muted">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="text-sm text-ebg-muted">Login</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="btn-gold text-sm px-5 py-2 rounded-md text-center">Become a Partner</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
